export function FindTypeInfoObj(fieldID, typeInfoList) {
  var match = null;
  var n = typeInfoList.length;

  for (var j = 0; j < n; j++) {
    var tI = typeInfoList[j];
    if (tI.fFieldID == fieldID) return tI;
  }

  return null;
}
